module.exports = __webpack_public_path__ + "static/media/Armando.af820656.JPG";